import { useState } from 'react';
import manifest from '../generated/landingImages.json';

type Props = { src: string; alt: string; sizes: string; priority?: boolean };

export default function LandingImage({ src, alt, sizes, priority = false }: Props) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const asset = manifest[src as keyof typeof manifest];
  const useOriginal = failedSource === src || !asset;

  // Always expose a real URL: rendering must not depend on an observer callback.
  // The optimized artwork is small enough to download eagerly at normal priority.
  return (
    <img
      src={useOriginal ? src : asset.src}
      srcSet={useOriginal ? undefined : asset.srcSet}
      sizes={sizes}
      width={asset?.width}
      height={asset?.height}
      alt={alt}
      loading="eager"
      decoding="async"
      fetchPriority={priority ? 'high' : 'auto'}
      onError={useOriginal ? undefined : () => setFailedSource(src)}
    />
  );
}
